module.exports = __webpack_public_path__ + "img/dango-pic.ea168902.png";